import { formatDate } from "@/utils/dateUtils";

export const VEHICLE_DOCUMENT_CARD_CONFIGS = [
  {
    kind: "ownership_basis",
    label: "Договор аренды/лизинга",
    icon: "license",
  },
  {
    kind: "osago",
    label: "ОСАГО",
    icon: "license",
  },
  {
    kind: "kasko",
    label: "КАСКО",
    icon: "license",
  },
  {
    kind: "diagnostic_card",
    label: "ТО",
    icon: "time",
  },
  {
    kind: "sts",
    label: "СТС",
    icon: "passport",
  },
  {
    kind: "pts",
    label: "ПТС",
    icon: "passport",
  },
];

const ICON_BY_KIND = Object.fromEntries(
  VEHICLE_DOCUMENT_CARD_CONFIGS.map((config) => [config.kind, config.icon])
);

const STATUS_LABELS = {
  filled: "Заполнен",
  missing: "Не заполнен",
  expired: "Просрочен",
  warning: "Скоро истекает",
};

export function vehicleDocumentIconName(documentKind) {
  return ICON_BY_KIND[documentKind] || "license";
}

export function vehicleDocumentCardConfigs(documents = []) {
  const configuredKinds = new Set(
    VEHICLE_DOCUMENT_CARD_CONFIGS.map((config) => config.kind)
  );

  const additionalConfigs = documents
    .filter((document) => document?.document_kind && !configuredKinds.has(document.document_kind))
    .map((document) => ({
      kind: document.document_kind,
      label: document.document_name || document.document_kind,
      icon: vehicleDocumentIconName(document.document_kind),
    }));

  return [
    ...VEHICLE_DOCUMENT_CARD_CONFIGS,
    ...uniqueConfigsByKind(additionalConfigs),
  ];
}

export function vehicleDocumentStatus(document) {
  if (!document) return "missing";
  if (vehicleDocumentExpired(document)) return "expired";
  if (vehicleDocumentExpiringSoon(document)) return "warning";

  return "filled";
}

export function vehicleDocumentStatusLabel(status) {
  return STATUS_LABELS[status] || STATUS_LABELS.filled;
}

export function vehicleDocumentCardStatusLabel(document) {
  if (!document) return "Не добавлен";

  const status = vehicleDocumentStatus(document);
  if (status === "expired") return "Просрочено";
  if (status === "warning") return "Истекает";

  return "";
}

export function vehicleDocumentMeta(document, emptyValue = "") {
  const parts = [
    document?.document_number ? `№ ${document.document_number}` : null,
    document?.document_date ? `от ${formatDate(document.document_date)}` : null,
    document?.ends_at ? `до ${formatDate(document.ends_at)}` : null,
  ].filter(Boolean);

  return parts.join(" · ") || emptyValue;
}

export function vehicleDocumentAttachmentsLabel(document) {
  const count = document?.attachments_count ?? (document?.attachments || []).length;
  if (count === 0) return "Файлы не приложены";
  if (count === 1) return "1 файл";
  if (count < 5) return `${count} файла`;

  return `${count} файлов`;
}

function vehicleDocumentExpired(document) {
  return Boolean(document?.ends_at && daysUntil(document.ends_at) < 0);
}

function vehicleDocumentExpiringSoon(document) {
  const days = daysUntil(document?.ends_at);
  return days !== null && days >= 0 && days <= 30;
}

function uniqueConfigsByKind(configs) {
  return configs.filter((config, index) =>
    configs.findIndex((item) => item.kind === config.kind) === index
  );
}

function daysUntil(value) {
  if (!value) return null;

  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return null;

  const now = new Date();
  date.setHours(0, 0, 0, 0);
  now.setHours(0, 0, 0, 0);

  return Math.ceil((date - now) / 86_400_000);
}
